import { createContext } from "react";

export const ApiResultContext = createContext({});